import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MinervaService {
  protected storage: Storage;
  protected httpOptions: any;
  protected token: any;
  protected customerId = '';


  constructor(private http: HttpClient) {
    this.storage = window.sessionStorage;
    this.token = this.storage.getItem('token');
    const itemUser = this.storage.getItem('user');
    const user = itemUser ? JSON.parse(itemUser) : {};
    this.customerId = user.customerId;

    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      })
    };
  }

  public getGeoJsonFile(file: string) {
    const params = new HttpParams().set('filePath', file);

    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params,
      responseType: 'blob' as 'json'
    };

    return this.http.get(`${environment.api}/reader-service/download`, this.httpOptions)
  }

  public getQRCodeFile(certificateNumber: string) {
    const params = new HttpParams().set('url', certificateNumber);

    this.httpOptions = {
      params,
      responseType: 'blob' as 'json'
    };

    return this.http.get(`${environment.api}/qrcode`, this.httpOptions)
  }

  getCriteriaReturnedName(type: string): string {
    let result: string;

    switch (type) {
      case 'indigenousLands':
        result = 'Terras Indígenas:'
        break;
      case 'burned':
        result = 'Queimadas:';
        break;
      case 'mapBiomasWarning':
        result = 'Alerta Map Biomas:';
        break;
      case 'mapBiomas':
        result = 'Map Biomas:';
        break;
      case 'archeologicalSites':
        result = 'Sitios Arqueológicos:';
        break;
      case 'archeologicalSitesArea':
        result = 'Sitios Arqueológicos Área:';
        break;
      case 'property':
        result = 'Propriedade:';
        break;
      case 'editing':
        result = 'Area resumida:';
        break;
      case 'conservationUnit':
        result = 'Unidades de Conservação de Proteção Integral:';
        break;
      case 'deter':
        result = 'Deter:';
        break;
      case 'deterAmazon':
        result = 'Deter Amazônia:';
        break;
      case 'deterCerrado':
        result = 'Deter Cerrado:';
        break;
      case 'deterPantanal':
        result = 'Deter Pantanal:';
        break;
      case 'ibamaEmbargo':
        result = 'Embargos Ibama:';
        break;
      case 'ibamaEmbargoByProducer':
        result = 'Embargo Ibama Lista:';
        break;
      case 'indigenousLand':
        result = 'Terra Indígena:';
        break;
      case 'prodesAmazon':
        result = 'Prodes Amazônia:';
        break;
      case 'prodesAtlanticForest':
        result = 'Prodes Mata Atlântica:';
        break;
      case 'prodesCaatinga':
        result = 'Prodes Caatinga:';
        break;
      case 'prodesCerrado':
        result = 'Prodes Cerrado:';
        break;
      case 'prodesPampa':
        result = 'Prodes Pampa:';
        break;
      case 'prodesPantanal':
        result = 'Prodes Pantanal:';
        break;
      case 'publicForests':
        result = 'Florestas Públicas:';
        break;
      case 'quilombolaAreas':
        result = 'Territórios Quilombolas::';
        break;
      case 'slavery':
        result = 'Lista Suja do Trabalho Escravo::';
        break;
      case 'miningAreas':
        result = 'Área de Mineração:';
        break;
      case 'ldiAutomatic':
        result = 'LDI Automatizado:';
        break;
      case 'ldiManual':
        result = 'LDI Manual:';
        break;
      case 'ldi':
        result = 'LDI:';
        break;
      case 'icmBio':
        result = 'ICMBio:';
        break;
      case 'cndCriminal':
        result = 'CND Criminal:';
        break;
      case 'ceis':
        result = 'CEIS:';
        break;
      case 'cndFgts':
        result = 'CND FGTS:';
        break;
      case 'cndTrabalhista':
        result = 'CND Trabalhista:';
        break;
      case 'distribuicaoCriminal':
        result = 'Distribuição Criminal:';
        break;
      case 'vegetacao':
      case 'vegetacao_MT':
      case 'vegetacao_PR':
      case 'vegetacao_RS':
        result = 'Vegetação:';
        break;
      case 'soja':
      case 'soja_MT':
      case 'soja_PR':
      case 'soja_RS':
        result = 'Soja:';
        break;
      case 'renovaBio':
        result = 'RenovaBio:';
        break;
      case 'status':
        result = 'Status Car:';
        break;
      case 'area':
        result = 'Área:';
        break;
      case 'bioma':
        result = 'Bioma:';
        break;
      default:
        result = '';
        break;
      case 'icmBioInfraction':
        result = 'Infrações ICMBio:';
        break;
      case 'Embargo ICMBio':
        result = 'Embargos ICMBio:';
        break;
      case 'icmBioEmbargo':
        result = 'Embargos ICMBio:';
        break;
      /*case 'icmBioEmbargoByProducer':
        result = 'Embargo ICMBio por Produtor';
        break;
      case 'icmBioInfractionByProducer':
        result = 'Infrações ICMBio por Produtor';
        break;*/
    }

    return result;
  }
  
  getPropertyData(payload: {protocolName: string; customerId: string; providerDocument: string; reference?: string}): Observable<any> {
    const params = new HttpParams()
      .set('providerDocument', payload.providerDocument ? payload.providerDocument : '')
      .set('customerId', payload.customerId ? payload.customerId : '')
      .set('protocolName', payload.protocolName ? payload.protocolName : '')
      .set('reference', payload.reference ? payload.reference : '');

    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
      params,
    };
    return this.http.get<any>(`${environment.api}/quality-chain`, http);
  }

  getQualityChainById(qualityChainId: string): Observable<any> {
    
    const params = new HttpParams().set('qualityChainId', qualityChainId);

    return this.http.get<any>(`${environment.api}/quality-chain/get-quality-chain-id`, {params});
  }

}
